import styled from "styled-components";
import { Anchor, Flex, Type } from "discover.medical.react-component-library";

export const Header = styled(Flex)`
  background: ${({ $planType, theme }) =>
    $planType === "premium" ? `#00758D` : `#3D3F42`};
`;

export const Content = styled(Flex)`
  gap: 0.75rem;
  padding: ${({ theme }) => theme.space.lg} 1.375rem 2rem;
`;

export const Description = styled.div`
  text-align: center;
`;

export const Buttons = styled(Flex)`
  flex: 1;
  gap: 1rem;
  margin-top: ${({ theme }) => theme.space.sm};
`;

export const FreeTrialButton = styled(Anchor)`
  > span {
    background: #00758d;
    font-weight: ${({ theme }) => theme.font.weight.semibold};
  }
  > span:hover {
    background: #00758d;
  }
`;

export const Price = styled(Type)`
  font-size: 2.25rem;
  line-height: 1;
`;
